/**
 * 新专区版本游戏模块通用mixins
 * 主要是 Detail.vue 和 MonthCardDetail.vue 里通用的一部分逻辑
 */

import { mapGetters, mapActions, mapState } from "vuex"
import * as url from "../../utils/url"
import * as enums from "../../store/enums"
import * as langs from "../../constants/langs"
import * as errorMaps from "../../constants/error_map"
import _ from "lodash"

export default {
  data() {
    return {
      groupId: null,
      busId: null,
      goodsId: null,
      cardId: null,
      cdkeySerialNum: null,
      // 大区id
      zoneId: null,
      // 大区名称
      zoneName: "",
      // 角色名称
      roleName: "",
      gameid: null,
      gamePlatformId: null,
      goods_zoneid: "",

      // 服务条款
      privacyUrl: "",
      serviceUrl: "",

      // 是否是直接进入该路由
      isStraightLink: false,
      // 是否来自专区页
      isFromServiceZone: false
    }
  },

  computed: {
    ...mapGetters([
      "userAgent",
      "loginState",
      "isWechatLoginState",
      "isQQLoginState",
      "provideUin",
      "currentItem",
      "provideAccountType",
      "offerId",
      "fromMini",
      "zoneRecommend",
      "zoneRoleInfoCache"
    ]),
    ...mapState({
      userInputQQforZone: ({ zone }) => zone.userInputQQforZone
    }),
    systemEnv() {
      let plat = this.userAgent.iOS ? "iOS" : "安卓"
      let accountType = ""
      if (this.isWechatLoginState) {
        accountType = "微信"
      } else if (this.isQQLoginState) {
        accountType = "QQ"
      }
      return accountType ? `${accountType}-${plat}` : "请登录"
    },

    zoneInfo() {
      if (!this.zoneName) return "请选择游戏大区"
      return this.zoneName + " " + (this.roleName ? this.roleName : "")
    },

    // 登录态的账户类型
    accountType() {
      let accountType = this.userAgent.weixin ? "WX" : "QQ"
      if (this.loginState.sessionId == "hy_gameid" && this.loginState.sessionType == "wc_actoken") {
        accountType = "WX"
      } else if (this.loginState.sessionId == "uin" || ["kp_actoken", "kp_accesstoken"].indexOf(this.loginState.sessionType) > -1) {
        accountType = "QQ"
      }
      return accountType
    },
    // 是否是端游专区
    isPcGame() {
      return this.currentItem.categoryId === enums.BUSINESS_TYPE.PC_GAME
    },
    // 是否是手游专区
    isMobileGame() {
      return this.currentItem.categoryId === enums.BUSINESS_TYPE.MOBILE_GAME
    },
    // QQ登录态展示QQ号码
    showQQNumber() {
      if (this.accountType == "QQ" && this.loginState.sessionId == "uin") {
        return this.loginState.openid
      }
      return ""
    }
  },

  methods: {
    ...mapActions(["reportUserAction", "setLoadingStart", "setLoadingEnd", "initMonthCard", "setUserInputQQforZone", "jumpToErrorPage"]),
    initBeforeRouteEnter(vm, to, from) {
      // 判断是否直接进入，直接进入隐藏箭头
      if (url.getParam("isFromShop")) {
        vm.isStraightLink = false
      } else if (from.path === "/" && from.matched && from.matched.length === 0) {
        vm.isStraightLink = true
      } else {
        vm.isStraightLink = false
        if (from.path.indexOf("order") > -1) this.isFromServiceZone = true
      }

      // 设置基础路由参数信息
      vm.groupId = to.params.bizgroupid
      vm.busId = to.params.bizid
      vm.goodsId = to.params.goodsid
      vm.cardId = to.params.cardId
      vm.cdkeySerialNum = to.params.cdkey

      if (!vm.groupId || !vm.busId) {
        vm.jumpToErrorPage({
          msg: "未定义的业务"
        })
        return
      }

      vm.clearZoneInfo() // 清空大区选择信息
    },

    // 切换大区角色
    changeGameRoleZone() {
      // 非QQ互联场景下，需要校验用户是否输入QQ号
      if (
        langs.QQ_CONNECT_SESSION_TYPE.indexOf(this.loginState.sessionType) == -1 &&
        this.provideAccountType == enums.ACCOUNT_TYPE.QQ &&
        !this.provideUin &&
        this.currentItem.categoryId === enums.BUSINESS_TYPE.PC_GAME
      ) {
        this.$store.dispatch("setToastMsg", errorMaps.USER_HELPER.NO_INPUT_QQ)
        return
      }

      let userInputQQForZoneCopy = _.cloneDeep(this.userInputQQforZone)

      userInputQQForZoneCopy[this.currentItem.offerId] = this.provideUin
      this.setUserInputQQforZone(userInputQQForZoneCopy)

      this.$router.push({
        path:
          "/gameZone/" +
          this.currentItem.groupId +
          "/" +
          this.currentItem.busId +
          (this.currentItem.categoryId == 1 ? "/mobileArea" : "/area"),
        query: {
          ru: encodeURIComponent(url.delParam(["code"], location.href))
        }
      })
    },

    // 清空zoneInfo
    clearZoneInfo() {
      this.zoneId = null
      this.zoneName = ""
      this.roleName = ""
      this.gameid = null
      this.gamePlatformId = null
    },

    // 设置大区等信息
    setZoneInfo(accountId, vm = null, checkType = 2) {
      if (!vm) {
        vm = this
      }

      let offerId =
        vm.currentItem.categoryId === enums.BUSINESS_TYPE.MOBILE_GAME
          ? vm.currentItem[this.userAgent.iOS ? "ios" : "android"][vm.provideAccountType.toLowerCase()].offerid
          : vm.currentItem.offerId

      // 传入的点券offerId是做缓存使用，实际查询使用的道具offerid
      return vm.$store
        .dispatch("getZoneInfo", {
          accountId: accountId,
          offerId,
          checkType: checkType,
          hashquery: vm.$route.query
        })
        .then(zoneInfo => {
          vm.zoneId = zoneInfo.zoneId
          vm.zoneName = zoneInfo.zoneName.split("/")[0]
          vm.roleName = zoneInfo.roleName || zoneInfo.zoneName.split("/")[1]
          vm.gameid = zoneInfo.gameid
          vm.gamePlatformId = zoneInfo.gamePlatformId

          return zoneInfo
        })
    },

    /**
     * 获取用户游戏月卡信息
     * @param groupId
     * @param busId
     * @param vm
     * @returns {Promise<any>}
     */
    getUserMonthCardInfo({ groupId, busId, cardId, vm = null }) {
      if (!vm) {
        vm = this
      }

      return vm
        .getCurrentBizDetail({
          bizgroupid: groupId,
          bizid: busId
        })
        .then(() => {
          // 手游切新选大区组件，先初始化
          if (vm.isMobileGame) {
            vm.newZoneAndRoleSelector()
          }
        })
        .then(() => {
          if (vm.isMobileGame) {
            // 手游专区切大区组件
            return vm.parseCachedZoneRole({
              offerId: vm.amsOfferId,
              userId: vm.getAccountId()
            })
          } else {
            // 月卡使用游戏币对应的zoneid
            return vm.setZoneInfo(vm.loginState.openid, vm, 1)
          }
        })
        .then(zoneInfo => {
          let userZoneInfo
          // 这里由于新大区组件和老选大区方式返回的数据结构不同，需要先处理下
          if (zoneInfo && zoneInfo.selectedZone) {
            userZoneInfo = vm.handleZoneInfo(zoneInfo)
            // 将大区角色信息设为全局
            vm.setZoneSelectorZoneInfo(userZoneInfo)
          } else {
            userZoneInfo = zoneInfo
          }
          return vm.initMonthCard({
            groupId,
            busId,
            cardId,
            zoneId: userZoneInfo && userZoneInfo.zoneId
          })
        })
    }
  }
}
